<script setup lang="ts">
import { $t } from "@/i18n";
import { useRoute } from "vue-router";
import { computed, ref, watch } from "vue";
import { useDefaultStore } from "@/store";

const store = useDefaultStore();
const route = useRoute();
const activeTab = ref<any>();

const navList = computed(() => {
	return [
		{
			name: "LegalPage",
			label: $t("app.blogTypeLegal"),
			routeName: "LegalPage",
		},
		{
			name: "RegularPage",
			label: $t("app.blogTypeRegular"),
			routeName: "RegularPage",
		},
	];
});

const initializeActiveTab = () => {
	activeTab.value = findActiveTab(route.path);
};

const findActiveTab = (path: string) => {
	if (path.startsWith("/pravna")) {
		return navList.value.find((tab) => tab.routeName === "LegalPage");
	} else if (path.startsWith("/blog") || path.startsWith("/fizicka")) {
		return navList.value.find((tab) => tab.routeName === "RegularPage");
	} else {
		return null;
	}
};

watch(
	() => route.path,
	(newPath, oldPath) => {
		activeTab.value = findActiveTab(newPath);
		store.activeCardLegal = 7;
		store.activeCardRegular = 2;
	},
);

onMounted(() => {
	initializeActiveTab();
});
</script>

<template lang="pug">
.center
	.menu
		uni-tabs(
			:tabs="navList",
			:activeTab="activeTab",
			:can-close-tabs="false",
			:modern-ui="true",
			:is-top-line="false"
		)
</template>

<style lang="scss" scoped>
.center {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	background-color: $app-dark-color;
	height: $nav-top-bar-sm;
	// flex: 1;
	padding: 0 24px;
	display: flex;
	align-items: stretch;
	white-space: nowrap;
	// font-weight: 500;
	z-index: 998;
	justify-content: center;
}

.uni-tabs-wrap {
	height: 100% !important;
}

.menu {
	:deep() {
		.uni-tabs {
			gap: 55px;
		}

		.line-wrapper {
			margin: 0 !important;
			height: 5px !important;
			.line {
				height: 5px !important;
				background-color: $app-accent-color1 !important;
			}
		}

		.tab {
			padding: 0 !important;
			.row {
				align-items: end !important;
				.name,
				.label {
					font-family: "Galano Grotesque", sans-serif;
					color: $text-color-lighter !important;
					font-size: 18px !important;
					font-weight: 500 !important;
					line-height: 28.1px !important;
				}
			}

			&.tab-active {
				.row {
					align-items: end !important;
					.name,
					.label {
						font-family: "Galano Grotesque", sans-serif;
						color: $app-accent-color1 !important;
						font-size: 18px !important;
						font-weight: 500 !important;
						line-height: 28.1px !important;
					}
				}
			}
		}
	}
}

@media screen and (width >= 768px) {
	.center {
		height: $nav-top-bar !important;
	}
	.menu {
		display: flex;

		:deep() {
			.tab {
				.row {
					.name,
					.label {
						font-size: 30px !important;
						font-weight: 500 !important;
						line-height: 40.1px !important;
					}
				}

				&.tab-active {
					.row {
						.name,
						.label {
							font-size: 30px !important;
							font-weight: 500 !important;
							line-height: 40.1px !important;
						}
					}
				}
			}
		}
	}
}

@media screen and (width >= 1024px) {
	.center {
		padding: 0 85px !important;
	}
	.menu {
		:deep() {
			.tab {
				font-size: 0.95rem;
			}
		}
	}
}
</style>
